<template>
  <div
    v-if="isLoading"
    class="overlay"
  >
    <div class="spinner-container">
      <ProgressSpinner
        class="overlay-spinner"
        style="width: 56px; height: 56px"
        strokeWidth="4"
        fill="transparent"
        animationDuration=".8s"
        aria-label="Loading"
      />
      <div class="mt-4 text-xl font-medium">{{ message }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FullScreenOverlayLoader",
    props: {
      isLoading: {
        type: Boolean,
        required: true,
        default: false
      },
      message: {
        type: String,
        default: "Loading..."
      }
    }
  };
</script>

<style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.65); /* Darker overlay for better spinner visibility */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Ensure it's on top of other content */
  }

  .spinner-container {
    text-align: center;
    color: white;
  }

  /* High-visibility spinner: white stroke on dark overlay */
  .overlay-spinner :deep(svg circle) {
    stroke: white;
  }

  .overlay-spinner :deep(.p-progress-spinner-circle) {
    stroke: white;
  }

  /* Blur effect for the background content */
  .overlay::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    backdrop-filter: blur(2px); /* Adjust blur amount as needed */
    z-index: -1; /* Place behind the overlay content */
  }
</style>
